<template>

  <div class="ue-expenses-edit">
    <el-card>
      <div class="header">
        <h2>169 - Международные (Год: {{ dto.trancheYear }})</h2>
        <div>
          <el-button @click="goBack">Назад</el-button>
          <el-button type="primary" @click="submitForm()" :loading="isLoading" v-if="dto.status !== 'APPROVED' && hasEditPermission()">Сохранить</el-button>
        </div>
      </div>

      <form>

        <div class="table-container" @paste="handlePaste" @keydown="handleKeydown">
          <table class="grid-table">
            <thead>
            <tr>
              <th class="title-cell header-success" rowspan="2">Наименование</th>
              <th class="meta-cell header-success" rowspan="2">Единица измерения</th>
              <th class="meta-cell header-success" rowspan="2">Количество</th>
              <th class="meta-cell header-success" rowspan="2">Средняя стоимость за единицу</th>
              <th class="meta-cell header-success" rowspan="2">Общая стоимость</th>
              <th class="total-cell header-success" rowspan="2">ВСЕГО</th>
              <th class="header-success" colspan="12">в т.ч. по месяцам</th>
              <th class="action-col" rowspan="2" v-if="dto.status !== 'APPROVED' && hasEditPermission()"></th>
            </tr>
            <tr>
              <th v-for="name in monthNames" :key="name" class="month-cell header-success">{{ name }}</th>
            </tr>
            </thead>
            <tbody>
            <tr class="total-row calculated-row readonly-text">
              <td>ВСЕГО</td>
              <td></td>
              <td>{{ formatNumber(dto.avgCount) }}</td>
              <td>{{ formatNumber(dto.avgCostPerUnit) }}</td>
              <td>{{ formatNumber(dto.avgCost) }}</td>
              <td>{{ formatNumber(dto.totalSum) }}</td>
              <td v-for="month in monthFields">{{ formatNumber(dto[month]) }}</td>
              <td v-if="dto.status !== 'APPROVED' && hasEditPermission()"></td>
            </tr>
            <template v-for="(cat, rowIndex) in dto.categories" :key="cat.uuid || rowIndex">
              <tr :class="{'total-row calculated-row readonly-text':cat.items?.length}" >
                <td>{{ catMap.catNames[cat.type] }}</td>
                <td>{{ catMap.catUnits[cat.type] }}</td>
                <td class="expense-sum-edit">
                  <span v-if="cat.items?.length">{{formatNumber(cat.avgCount)}}</span>
                  <input v-if="!cat.items?.length"
                      :value="getCellValue(cat, 'avgCount')"
                      @focus="onFocus($event, cat, 'avgCount')"
                      @blur="onBlur($event, cat, 'avgCount')"
                      @input="onInput($event, cat, 'avgCount')"
                      :data-row="rowIndex"
                      :data-col="0"
                      class="cell-input"
                      type="text"
                  />
                </td>
                <td class="expense-sum-edit">{{formatNumber(cat.avgCostPerUnit)}} </td>
                <td class="calculated-cell">{{ formatNumber(cat.avgCost) }}</td>
                <td class="calculated-cell">{{ formatNumber(cat.totalSum) }}</td>
                <td class="expense-sum-edit" v-for="field in monthFields">
                  <span v-if="cat.items?.length">{{formatNumber(cat[field])}}</span>
                  <input v-if="!cat.items?.length"
                      :value="getCellValue(cat, field)"
                      @focus="onFocus($event, cat, field)"
                      @blur="onBlur($event, cat, field)"
                      @input="onInput($event, cat, field)"
                      :data-row="rowIndex"
                      :data-col="0"
                      class="cell-input"
                      type="text"
                  />
                </td>

                <td class="action-col" v-if="dto.status !== 'APPROVED' && hasEditPermission()">
                  <el-button type="danger" size="small" @click="removeItem(rowIndex, cat)">
                    &times;
                  </el-button>
                </td>
              </tr>

              <tr v-for="(item, itemIndex) in cat.items" :key="item.uuid || itemIndex" class="row-sub-title">
                <td>{{ catMap.catNames[item.type] }}</td>
                <td>{{ catMap.catUnits[item.type] }}</td>
                <td class="expense-sum-edit">
                  <input
                      :value="getCellValue(item, 'avgCount')"
                      @focus="onFocus($event, item, 'avgCount')"
                      @blur="onBlur($event, item, 'avgCount')"
                      @input="onInput($event, item, 'avgCount')"
                      :data-row="rowIndex"
                      :data-col="0"
                      class="cell-input"
                      type="text"
                  />
                </td>
                <td class="calculated-cell">{{ formatNumber(item.avgCostPerUnit) }}</td>
                <td class="calculated-cell">{{ formatNumber(item.avgCost) }}</td>
                <td class="calculated-cell">{{ formatNumber(item.totalSum) }}</td>
                <td class="expense-sum-edit" v-for="field in monthFields">
                  <input
                      :value="getCellValue(item, field)"
                      @focus="onFocus($event, item, field)"
                      @blur="onBlur($event, item, field)"
                      @input="onInput($event, item, field)"
                      :data-row="rowIndex"
                      :data-col="0"
                      class="cell-input"
                      type="text"
                  />
                </td>

                <td class="action-col"></td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
      </form>

      <div class="d-flex align-items-center" v-if="dto.status !== 'APPROVED' && hasEditPermission()">
        <div class="mb-3">
          <el-select v-model="selectedCategory" placeholder="Выберите" size="small" style="width: 200px" >
            <el-option v-for="item in availableCategories()" :key="item.value" :label="item.title" :value="item.value"></el-option>
          </el-select>
        </div>

        <div class="mb-3" >
          <el-button type="success" size="small" @click="addItem" :disabled="!selectedCategory">
            <font-awesome-icon :icon="['fas', 'plus']"/> Добавить категорию
          </el-button>
        </div>
      </div>
    </el-card>
  </div>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import delegationService from "@/services/delegationService";
import ueExpensesCommonCrudService from "@/services/expenses/ueExpensesCommonCrudService";
import {handleGridKeydown} from "@/utils/gridKeyboardNav";

const MONTH_FIELDS = ['janSum', 'febSum', 'marSum', 'aprSum', 'maySum', 'junSum', 'julSum', 'augSum', 'sepSum', 'octSum', 'novSum', 'decSum'];
const ALL_PASTE_FIELDS = ['avgCount', 'avgCostPerUnit', 'avgCost', 'totalSum', ...MONTH_FIELDS];
export default {
  components: {
    VueLoading
  },
  computed: {
    uuid() {
      return this.$route.params.uuid;
    },
  },
  data() {
    return {
      isLoading: false,
      expenseType: 'international',
      dto: {
        uuid: null,
        trancheYear: null,
        universityId: null,
        status: null,
        categories: []
      },
      catMap: { catNames: {}, catUnits: {}},
      selectedCategory: null,
      focusedCell: null,
      monthFields: MONTH_FIELDS,
      monthNames: [
        'январь', 'февраль', 'март', 'апрель', 'май', 'июнь',
        'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь'
      ],
    };
  },
  methods: {
    init() {
      this.findById(this.uuid);
    },

    async findById(uuid) {
      this.isLoading = true;
      this.dto = await ueExpensesCommonCrudService.findById(this.expenseType, uuid);
      this.catMap = await ueExpensesCommonCrudService.getAllDefaultCategories(this.expenseType);
      if (!this.dto.categories) {
        this.dto.categories = [];
      }
      this.recalculate();
      this.isLoading = false;
    },
    async submitForm() {
      try {
        if (!this.hasEditPermission()) return;
        this.isLoading = true;
        this.dto = await ueExpensesCommonCrudService.save(this.expenseType, this.dto);
        if (!this.dto.categories) {
          this.dto.categories = [];
        }
        this.recalculate();
        showSuccessNotify("Успешно сохранено!");
      } catch (exc) {
        showErrorNotify("Возникла ошибка при сохранении");
      } finally {
        this.isLoading = false;
      }
    },
    availableCategories() {
      return this.catMap?.categories?.filter(c => !this.dto.categories.some(cat => cat.type === c.value));
    },
    addItem() {
      if (!this.selectedCategory) return;

      const cat = this.catMap?.categories?.find(c => c.value === this.selectedCategory);
      if (!cat) return;

      if (cat) {
        const dto = {type: cat.value};
        if (cat.hasSubItems) {
          dto.items = [];
          cat.items.forEach(sub => {
            dto.items.push({type: sub.value});
          });
        }
        this.dto.categories.push(dto);
      }
      this.selectedCategory = null;
      this.recalculate();
    },

    async removeItem(index, item) {
      if (item.uuid) {
        try {
          await ueExpensesCommonCrudService.deleteCategory(this.expenseType, this.dto.uuid, item.uuid);
          showSuccessNotify('Удалено');
        } catch (exc) {
          showErrorNotify('Ошибка при удалении');
          return;
        }
      }
      this.dto.categories.splice(index, 1);
      this.recalculate();
    },

    parseNumber(str) {
      if (str === null || str === undefined || str === '') return 0;
      const cleaned = String(str).replace(/\s/g, '').replace(',', '');
      const num = parseFloat(cleaned);
      return isNaN(num) ? 0 : num;
    },

    formatNumber(val) {
      const num = typeof val === 'number' ? val : this.parseNumber(val);
      if (num === 0) return '';
      return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },

    getCellValue(item, field) {
      if (this.focusedCell && this.focusedCell.item === item && this.focusedCell.field === field) {
        return this.editingValue;
      }
      return item && item[field]? this.getDisplayValue(item[field]): '';
    },
    getDisplayValue(val) {
      const num = this.parseNumber(val);
      if (num === 0) return '';
      return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },

    onFocus(event, item, field) {
      this.focusedCell = { item, field };
      const num = this.parseNumber(item[field]);
      this.editingValue = num === 0 ? '' : String(num).replace('.', ',');
      event.target.value = this.editingValue;
    },

    onBlur(event, item, field) {
      this.focusedCell = null;
      const num = this.parseNumber(event.target.value);
      item[field] = num === 0 ? null : Math.round(num * 100) / 100;
      event.target.value = this.getDisplayValue(item[field]);
      this.recalculate();
    },

    onInput(event, item, field) {
      this.editingValue = event.target.value;
      const num = this.parseNumber(event.target.value);
      item[field] = num === 0 ? null : num;
      this.recalculate();
    },


    recalculate() {
      if (!this.dto.categories || this.dto.categories.length === 0) {
        return;
      }

      this.dto.avgCount = 0;
      this.dto.avgCostPerUnit = 0;
      this.dto.avgCost = 0;
      this.dto.totalSum = 0;
      for (const field of this.monthFields) {
        this.dto[field] = 0;
        for (const cat of this.dto.categories) {
          if (cat.items?.length) {
            cat[field] = 0;
          }
        }
      }

      for (const cat of this.dto.categories) {

        if (cat.items?.length) {
          cat.avgCount = 0;
          cat.avgCostPerUnit = 0;
          cat.avgCost = 0;
          for (const item of cat.items) {
            item.totalSum = 0;
            for (const field of this.monthFields) {
              const val = this.parseNumber(item[field]);
              item.totalSum += val;
              cat[field] = (cat[field] || 0) + val;
            }
            item.avgCost = item.avgCount ? item.totalSum : 0;
            item.avgCostPerUnit = this.parseNumber(item.avgCount) > 0 ? (item.totalSum / this.parseNumber(item.avgCount)).toFixed(2) : 0;
            cat.avgCount += this.parseNumber(item.avgCount);
            cat.avgCostPerUnit += this.parseNumber(item.avgCostPerUnit);
            cat.avgCost += this.parseNumber(item.avgCost);
          }
        } else {
          cat.avgCost = cat.totalSum;
          cat.avgCostPerUnit = this.parseNumber(cat.avgCount) > 0 ? (cat.totalSum / this.parseNumber(cat.avgCount)).toFixed(2) : 0;
        }

        cat.totalSum = 0;
        for (const field of this.monthFields) {
          const val = this.parseNumber(cat[field]);
          cat.totalSum += val;
          this.dto[field] += val;
        }
        this.dto.avgCount += this.parseNumber(cat.avgCount);
        this.dto.avgCost += this.parseNumber(cat.avgCost);
        this.dto.totalSum += cat.totalSum;
      }

    },

    handleKeydown(event) {
      handleGridKeydown(event, this.$el);
    },

    handlePaste(event) {
      const target = event.target;
      if (!target || target.tagName !== 'INPUT') return;

      const startRow = parseInt(target.dataset.row);
      const startCol = parseInt(target.dataset.col);
      if (isNaN(startRow) || isNaN(startCol)) return;

      const clipboardData = event.clipboardData || window.clipboardData;
      if (!clipboardData) return;

      const text = clipboardData.getData('text/plain');
      if (!text) return;

      const rows = text.split(/\r?\n/).filter(r => r.trim() !== '');
      if (rows.length <= 1 && !rows[0].includes('\t')) return;

      event.preventDefault();

      for (let r = 0; r < rows.length; r++) {
        const cols = rows[r].split('\t');
        const itemIdx = startRow + r;
        if (itemIdx >= this.dto.categories.length) break;

        for (let c = 0; c < cols.length; c++) {
          const colIdx = startCol + c;
          if (colIdx >= ALL_PASTE_FIELDS.length) break;

          const num = this.parseNumber(cols[c]);
          this.dto.categories[itemIdx][ALL_PASTE_FIELDS[colIdx]] = num === 0 ? null : num;
        }
      }

      this.recalculate();
      this.$forceUpdate();
    },

    goBack() {
      this.$router.go(-1);
    },
    hasEditPermission() {
      return this.isUniversityManager() && (this.dto.status === 'CREATED' || !this.dto.status);
    },
    isUniversityManager() {
      return delegationService.isUniversityManager();
    },
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped>
.header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; }
.table-container { width: 100%; overflow-x: auto; }
.grid-table { width: 100%; border-collapse: collapse; min-width: 3000px; }
.grid-table th, .grid-table td { border: 1px solid #EBEEF5; padding: 8px; font-size: 12px; }
.grid-table th { background-color: #f5f7fa; text-align: center; font-weight: bold; position: sticky; top: 0; z-index: 10; }
.header-success { background-color: #d4edda !important; }
.title-cell { width: 180px; min-width: 180px; }
.row-sub-title td {
  padding-left: 15px;
  font-style: italic;
}
.meta-cell { width: 60px; min-width: 60px; }
.month-cell { width: 85px; min-width: 85px; }
.total-cell { width: 100px; min-width: 100px; }
.action-col { width: 50px; min-width: 50px; text-align: center; }
.name-cell { min-width: 180px; }
.calculated-cell { text-align: right; background-color: #f9f9f9; }
.calculated-row { background-color: #f0f9eb; font-weight: bold; }
.readonly-text { text-align: right; padding-right: 10px !important; }
.total-row td { font-weight: bold; text-align: right; }
.total-row td:first-child { text-align: left; }

.expense-sum-edit { padding: 2px !important; }

.cell-input {
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
  text-align: right;
  font-size: 12px;
  padding: 4px 6px;
  box-sizing: border-box;
}

.cell-input.text-left {
  text-align: left;
}

.cell-input:focus {
  background-color: #fff;
  border: 1px solid #409eff;
  border-radius: 2px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}
</style>
